import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Row, Nav, Col } from "react-bootstrap";
import "./style.scss";
import TopNavigation from "../../components/TopNavigation";
import ReceivedContent from "./receivedContent";
import RedeemedContent from "./redeemedContent";

import * as Assets from "../../utils/svg_assets";
import { Base } from "../../components/RootLayout";
import { formatShowDate, reverseDateString } from "../../utils/utilities";
import { useParams } from "react-router-dom";

const now = new Date(Date.now());
now.setDate(1);

const StarHistory = (props) => {
  const { typeTab } = useParams();
  const [activeTabs, setActiveTabs] = useState(typeTab ? typeTab : "received");
  const [data, setData] = useState([]);
  const [receivedData, setReceivedData] = useState([]);
  const [redeemedData, setRedeemedData] = useState([]);
  const [date, setDate] = useState(now);
  const onChangeTabs = (tabActive) => {
    setActiveTabs(tabActive);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (data.length > 0) {
      let receivedList = data.filter((item) => item.points > 0);
      let redeemedList = data.filter((item) => item.points < 0);
      setReceivedData(receivedList);
      setRedeemedData(redeemedList);
    } else {
      setReceivedData([]);
      setRedeemedData([]);
    }
  }, [data]);

  const setMonth = (month) => {
    date.setMonth(month);
    let newDate = new Date(date.getFullYear(), date.getMonth(), 1);
    if (newDate.getTime() <= now.getTime()) {
      setDate(newDate);
      fetchData();
    }
  };

  const fetchData = async () => {
    await props
      .getStarHistory({ date: reverseDateString(date) })
      .then(function (response) {
        setData(response.data);
      })
      .catch(function (error) {
        setData([]);
      });
  };

  return (
    <Base>
      <TopNavigation
        titlePage="Star History"
        toPath={-1}
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconFilter}
      />
      <div className="star-history-content">
        <div className="star-history-nav">
          <Row>
            <Nav
              className="justify-content-center"
              variant="pills"
              defaultActiveKey={activeTabs}
            >
              <Nav.Item>
                <Nav.Link
                  eventKey="received"
                  onClick={() => onChangeTabs("received")}
                >
                  Received
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  eventKey="redeemed"
                  onClick={() => onChangeTabs("redeemed")}
                >
                  Redeemed
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Row>

          <Row className="received-content">
            <div className="received">
              <Row className="received-header">
                <Col
                  xs={3}
                  sm={3}
                  md={3}
                  className="header-left"
                  onClick={() => setMonth(date.getMonth() - 1)}
                >
                  <img
                    src={Assets.iconArrowLeft}
                    className="header-left-image"
                    alt="cl_image"
                  />
                </Col>
                <Col xs={6} sm={6} md={6} className="header-center">
                  {formatShowDate(date)}
                </Col>
                <Col
                  xs={3}
                  sm={3}
                  md={3}
                  className="header-right"
                  onClick={() => setMonth(date.getMonth() + 1)}
                >
                  <img
                    src={Assets.iconArrowRight}
                    className="header-right-image"
                    alt="cr_image"
                  />
                </Col>
              </Row>
            </div>
          </Row>
          {activeTabs === "received" && (
            <Row className="received-content">
              <ReceivedContent data={receivedData} />
            </Row>
          )}
          {activeTabs === "redeemed" && (
            <Row className="redeemed-content">
              <RedeemedContent data={redeemedData} />
            </Row>
          )}
        </div>
      </div>
    </Base>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  getStarHistory: dispatch.FinanceSM.getStarHistory,
});

export default connect(mapStateToProps, mapDispatchToProps)(StarHistory);
